<template>
  <btn
    component-name="btn-primary"
    class="inline-flex justify-center items-center whitespace-nowrap truncate max-w-full"
  >
    <template v-slot:default="slotProps">
      <span
        class="inline-flex justify-center items-center gap-sm max-w-full truncate"
        :class="{
          'text-button': slotProps.size === 'regular',
          'text-button-small': slotProps.size === 'small',
          'opacity-60 !pointer-events-none': slotProps.disabled,
        }"
      >
        <span
          class="truncate first-letter:uppercase underline decoration-transparent group-hover:decoration-current transition-[text-decoration] duration-300 ease-in-out"
          :class="{
            'underline-offset-2': slotProps.size === 'small',
          }"
          >{{ slotProps.title }}</span
        >
        <vector-icon
          v-if="slotProps.icon"
          :icon="slotProps.icon"
          size="small"
          class="scale-100 group-hover:scale-[115%] transition-transform duration-[350ms] ease-in-out will-change-transform"
          :class="{
            'group-hover:scale-[115%]': slotProps.size === 'regular',
            'group-hover:scale-[120%]': slotProps.size === 'small',
          }"
        />
      </span>
    </template>
  </btn>
</template>
